import { createReducer, on } from '@ngrx/store';
import * as ConnectionsActions from './connections.actions';
import { ConnectionsState } from './connections.state';
import { IConnection } from '../model/connection.model';
import { IUser } from '../../user/model/user.model';

export const initialConnectionsState: ConnectionsState = {
  connections: [] as IConnection[],
  pendingConnections: [] as IConnection[],
  searchResults:[] as IUser[],
  selectedConnections: [] as IConnection[]
};
 
export const connectionsReducer = createReducer(
    initialConnectionsState,
    on( ConnectionsActions.connectionsActions.getConnectionsSuccess, (state , { connections }) => ({ 
      ...state, 
      connections: connections
    })),
    on( ConnectionsActions.connectionsActions.deleteConnectionSentSuccess, (state , { connection }) => ({ 
      ...state, 
      connections: [...state.connections.filter(x => x.id !== connection.id)]
    })),
    on( ConnectionsActions.connectionsActions.searchConnectionSentSuccess, (state , { searchResults }) => ({ 
      ...state, 
      searchResults: searchResults
    })),
    on( ConnectionsActions.connectionsActions.getPendingConnectionSuccess, (state , { connections }) => ({ 
      ...state, 
      pendingConnections: connections
    })),
    on( ConnectionsActions.connectionsActions.requestConnectionSentSuccess, (state , { connection }) => ({ 
      ...state, 
      connections: [...state.connections, connection]
    })),
    on(ConnectionsActions.connectionsActions.selectConnection, (state, { connectionId }) => {
      if (state.connections === undefined || state.connections === null)
        return state;
      else {
        const selectedConnection = state.connections.find(x => x.id === connectionId);
        if (!selectedConnection) {
          return state;
        }
        return {
          ...state,
          selectedConnections: state.selectedConnections
            ? [...state.selectedConnections.filter(x => x.id !== connectionId), selectedConnection]
            : [selectedConnection],
        };
      }
    }),   

    on( ConnectionsActions.connectionsActions.unselectConnection, (state , { connectionId }) => { 
      return {
        ...state, 
        selectedConnections: [...state.selectedConnections?.filter(x => x.id !== connectionId)]
      };
    }),

    on( ConnectionsActions.connectionsActions.clearSelectConnection, (state , {}) => { 
      return {
        ...state,
        selectedConnections: []
      };
    }),        

    on( ConnectionsActions.connectionsActions.clearAllSelectConnection, (state , {}) => { 
      return {
        ...state,
        selectedConnections: [],
        connections: []
      };
    })        
);
